import { useShopSettings } from "@/context/ShopSettingsContext";

const SIZES = {
  lg: "gap-2.5 px-6 py-3.5 text-base",
  md: "gap-2 px-4 py-2 text-sm",
  sm: "gap-1.5 px-3 py-1.5 text-xs",
};

const trackClick = (product, placement, href) => {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", "tiktok_shop_click", {
    item_id: product?.id || "",
    item_name: product?.name || "",
    placement,
    link_url: href,
    transport_type: "beacon",
  });
};

export const TikTokShopButton = ({ product, size = "md", label = "Acquista su TikTok Shop", className = "", testId, placement = "product" }) => {
  const { tiktok_shop_url } = useShopSettings();
  const href = product?.tiktok_product_url || tiktok_shop_url;
  if (!href) return null;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      onClick={() => trackClick(product, placement, href)}
      className={`tiktok-btn inline-flex items-center justify-center rounded-full font-extrabold text-white ${SIZES[size]} ${className}`}
    >
      <i className="fa-brands fa-tiktok" aria-hidden="true" />
      <span>{label}</span>
    </a>
  );
};
